// -- other --
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import toast,{Toaster} from 'react-hot-toast';
import {all_routes} from "./feature-module/router/all_routes";
import {Title,Type,Config,Field} from "./constant";
// -- biz9  --
import {Obj,Log,Str,Num} from "biz9-utility";
import {Page_Logic,Portal_Table,Portal_Field,Portal_Page,Portal_Title,Template_Logic,Portal_Type,Portal_Value_Type} from "biz9-portal-app";
import {Data_Logic,Storage_Data} from "biz9-data-app";
import {User_Table,User_Logic} from "biz9-user";
import {Store_Type} from "biz9-store";
import {Image_Logic} from "biz9-image";
import {Remote} from "biz9-remote";
var platform = require('platform');
class Field_Logic {
    static get_sub_value_edit_link(item_sub_value_edit,portal_value_type,value_id) {
        const openNewWindow = (event) => {
            let value_title = '';
            event.preventDefault();
            let url = all_routes.dashboard_app_sub_value_edit_pop_open
                +"?parent_table="+item_sub_value_edit.parent_table
                +"&parent_id="+item_sub_value_edit.parent_id
                +"&event_handler="+item_sub_value_edit.event_handler
                +"&type="+portal_value_type
                +"&value_id="+value_id;
            Log.w('111_cool',url);
            const childWindow = window.open(url,'_blank','width=1000,height=600,left=0,top=0');
        };
        return (<Link onClick={openNewWindow}><FeatherIcon icon="edit" />{" { Edit " +value_id+" } "}</Link>);
    };
}
class App {
    static get_url(url) {
        return Remote.get_url(Config.APP_ID,Config.HOST,url);
    }
    static get_app_link_types(){
        return [{value:'production',label:'Production',title:'Production' },
            {value:'staging',label:'Staging',title:'Staging'},
            {value:'google_play',label:'Google Play',title:'Google Play' },
            {value:'apple_store',label:'Apple Store',title:'Apple Store' },
            {value:'cms',label:'Content Management System',title:'Content Management System'}];
    };
    static get_app_link_by_type(type){
        let match = Obj.find(Field.VALUE,type,App.get_app_link_types());
        if(match){
            return match;
        }else{
            return Obj.find(Field.VALUE,'staging',App.get_app_link_types());
        }
    };
    static get_product_app_types(){
        return [
            {value:Str.get_title_url(Title.PRODUCT_APP_TYPE_CMS),title:Title.PRODUCT_APP_TYPE_CMS}
        ];
    };
    static get_app_user_status_types(){
        return [
            {value:Str.get_title_url(Title.APP_USER_STATUS_TYPE_NOT_AVAILBLE),title:Title.APP_USER_STATUS_TYPE_NOT_AVAILBLE,label:Title.APP_USER_STATUS_TYPE_NOT_AVAILBLE},
            {value:Str.get_title_url(Title.APP_USER_STATUS_TYPE_PRODUCTION),title:Title.APP_USER_STATUS_TYPE_PRODUCTION,label:Title.APP_USER_STATUS_TYPE_PRODUCTION},
            {value:Str.get_title_url(Title.APP_USER_STATUS_TYPE_PLANNED_DOWNTIME),title:Title.APP_USER_STATUS_TYPE_PLANNED_DOWNTIME,label:Title.APP_USER_STATUS_TYPE_PLANNED_DOWNTIME},
            {value:Str.get_title_url(Title.APP_USER_STATUS_TYPE_PENDING),title:Title.APP_USER_STATUS_TYPE_PENDING,label:Title.APP_USER_STATUS_TYPE_PENDING},
        ];
    };
    static get_app_status_types(){
        return [
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_BALANCE_DUE),title:Title.APP_STATUS_TYPE_BALANCE_DUE,label:Title.APP_STATUS_TYPE_BALANCE_DUE},
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_DEVELOPMENT),title:Title.APP_STATUS_TYPE_DEVELOPMENT,label:Title.APP_STATUS_TYPE_DEVELOPMENT},
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_NEW),title:Title.APP_STATUS_TYPE_NEW,label:Title.APP_STATUS_TYPE_NEW},
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_NOT_AVAILBLE),title:Title.APP_STATUS_TYPE_NOT_AVAILBLE,label:Title.APP_STATUS_TYPE_NOT_AVAILBLE},
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_PRODUCTION),title:Title.APP_STATUS_TYPE_PRODUCTION,label:Title.APP_STATUS_TYPE_PRODUCTION},
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_PLANNED_DOWNTIME),title:Title.APP_STATUS_TYPE_PLANNED_DOWNTIME,label:Title.APP_STATUS_TYPE_PLANNED_DOWNTIME},
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_REMOVED),title:Title.APP_STATUS_TYPE_REMOVED,label:Title.APP_STATUS_TYPE_REMOVED},
            {value:Str.get_title_url(Title.APP_STATUS_TYPE_STAGING),title:Title.APP_STATUS_TYPE_STAGING,label:Title.APP_STATUS_TYPE_STAGING},
        ];
    };
    static get_app_status_type_by_type(status_type){
        return status_type ? Obj.find(Field.VALUE,status_type,App.get_app_status_types()) : {value:Str.get_title_url(Title.APP_STATUS_TYPE_NEW),title:Title.APP_STATUS_TYPE_NEW,label:Title.APP_STATUS_TYPE_NEW};
    };
    static get_app_user_status_type_by_type(user_status_type){
        return user_status_type ? Obj.find(Field.VALUE,user_status_type,App.get_app_user_status_types()) : {value:Str.get_title_url(Title.APP_USER_STATUS_TYPE_PENDING),title:Title.APP_USER_STATUS_TYPE_PENDING,label:Title.APP_USER_STATUS_TYPE_PENDING};
    };
    static get_app_status_type_by_title(status_title){
        return Obj.find(Portal_Field.TITLE,status_title,App.get_app_status_types());
    };
    static get_app_user_account_status_type_by_title(status_title){
        return Obj.find(Portal_Field.TITLE,status_title,App.get_user_app_status_type());
    };
    static get_user_account_status_types(){
        return [
            {value:Str.get_title_url(Title.USER_ACCOUNT_STATUS_TYPE_ACTIVE),title:Type.USER_ACCOUNT_STATUS_TYPE_ACTIVE},
            {value:Str.get_title_url(Title.USER_ACCOUNT_STATUS_TYPE_SUSPENDED),title:Type.USER_ACCOUNT_STATUS_TYPE_SUSPENDED},
            {value:Str.get_title_url(Title.USER_ACCOUNT_STATUS_TYPE_CLOSED),title:Type.USER_ACCOUNT_STATUS_TYPE_CLOSED},
        ];
    };
    static get_app_spec_weekly_hours(){
        let spec_weekly_hour_select = [];
        spec_weekly_hour_select.push({id:'1', title: "8 hours", value: '0',cost:'0'});
        spec_weekly_hour_select.push({id:'2', title: "20 hours", value: Str.get_money('250'),cost:'250'});
        spec_weekly_hour_select.push({id:'3', title: "40 hours", value: Str.get_money('500'),cost:'500'});
        return spec_weekly_hour_select;
    };
    static get_app_payment_plan_types(grand_total){
        let payment_plans = [];
        let payment_plan_4 = parseInt(grand_total)/4;
        let payment_plan_3 = parseInt(grand_total)/3;
        let payment_plan_2 = parseInt(grand_total)/2;
        let payment_plan_1 = grand_total;
        payment_plans.push({id:Store_Type.ORDER_PAYMENT_PLAN_1, title: "1 payment", value: String(payment_plan_1)});
        payment_plans.push({id:Store_Type.ORDER_PAYMENT_PLAN_2, title: "2 payments", value: String(payment_plan_2)});
        payment_plans.push({id:Store_Type.ORDER_PAYMENT_PLAN_3, title: "3 payments", value: String(payment_plan_3)});
        payment_plans.push({id:Store_Type.ORDER_PAYMENT_PLAN_4, title: "4 payments", value: String(payment_plan_4)});
        return payment_plans;
    };
    static get_app_delivery_time(cost){
        switch (true) {
            case (parseInt(cost) <= 300):
                return "Delivery in 1-2 weeks";
                break;
            case (parseInt(cost) <= 900):
                return "Delivery in 2-4 weeks";
                break;
            case (parseInt(cost) > 900):
                return "Delivery in 4-6 weeks";
                break;
            default:
            return "Delivery in 1-2 weeks";
        }
    };
}
class Data {
    static get_query_application_development_product_type_query_filter = (category) =>{
        let query_filter = {};
        if(!category){
            query_filter = {$or:[]};
        }else{
            query_filter = {$or:[],$and:[{category:category}]};
        }
        Data.PRODUCT_APP_TYPES.forEach(item => {
            query_filter.$or.push({type:item});
        });


        Log.w('11_query_filter',query_filter);

        return query_filter;
    };
    // -- product-apps --
    static PRODUCT_APP_TYPES = [
        'Content Management System',
        'Hosting',
        'Landing Page',
        'Mobile',
        'Website'
    ];
    static get_tables = () =>{
        return [
            {title:Title.BLOG_POST,type:Portal_Table.BLOG_POST,label:Title.BLOG_POST,value:Portal_Table.BLOG_POST},
            {title:Title.CATEGORY,type:Portal_Table.CATEGORY,label:Title.CATEGORY,value:Portal_Table.CATEGORY},
            {title:Title.CONTENT,type:Portal_Table.CONTENT,label:Title.CONTENT,value:Portal_Table.CONTENT},
            {title:Title.EVENT,type:Portal_Table.EVENT,label:Title.EVENT,value:Portal_Table.EVENT},
            {title:Title.GALLERY,type:Portal_Table.GALLERY,label:Title.GALLERY,value:Portal_Table.GALLERY},
            {title:Title.USER,type:Portal_Table.USER,label:Title.USER,value:User_Table.USER},
            {title:Title.PAGE,type:Portal_Table.PAGE,label:Title.PAGE,value:Portal_Table.PAGE},
            {title:Title.PRODUCT,type:Portal_Table.PRODUCT,label:Title.PRODUCT,value:Portal_Table.PRODUCT},
            {title:Title.SERVICE,type:Portal_Table.SERVICE,label:Title.SERVICE,value:Portal_Table.SERVICE},
            {title:Title.TYPE,type:Portal_Table.TYPE,label:Title.TYPE,value:Portal_Table.TYPE},
            {title:Title.SUB_VALUE,type:Portal_Table.SUB_VALUE,label:Title.SUB_VALUE,value:Portal_Table.SUB_VALUE}
        ];
    };
    static get_admin_stat_search_filter(val){
        return {stat_type:val};
    };
    static get_stat_search_option(parent_table,stat_type){
        switch(stat_type){
            case 'Type.STAT_CART':
            case 'Type.STAT_CART_ITEM':
            case 'Type.STAT_CART_SUB_ITEM':
            case 'Type.STAT_ORDER':
            case 'Type.STAT_ORDER_ITEM':
            case 'Type.STAT_ORDER_SUB_ITEM':
            case 'Type.STAT_FAVORITE':
            case 'Type.STAT_VIEW':
            case 'Type.STAT_REVIEW':
                return {get_user:true,get_join:true,field_keys:[{primary_table:parent_table,primary_field:'id',item_field:'parent_id',title:'parent_item'}]};
            default:
                return {get_user:true};
        }
    };
    static get_cms_items_option(category_table){
        let join_type_search = Data_Logic.get_join(Portal_Value_Type.ITEMS,Data_Logic.get_search(Portal_Table.TYPE,{},{},1,0),{title:'types'});
        let join_category_search = Data_Logic.get_join(Portal_Value_Type.ITEMS,Data_Logic.get_search(Portal_Table.CATEGORY,{category:Portal_Table.BLOG_POST},{
        },1,0),{title:'categorys'});
        return {joins:[join_type_search,join_category_search]};
    };
    static get_item_search_filter(val){
        let filter_query = {$or:[
            {title:{ $regex:".*"+String(val),$options:"i"}},
            {description:{ $regex:".*"+String(val),$options:"i"}},
        ]};
        return filter_query;
    };
    static get_user_search_filter(val){
        let filter_query = {$or:[
            {username:{ $regex:".*"+String(val),$options:"i"}},
            {first_name:{ $regex:".*"+String(val),$options:"i"}},
            {last_name:{ $regex:".*"+String(val),$options:"i"}},
            {email_name:{ $regex:".*"+String(val),$options:"i"}},
        ]};
        return filter_query;
    };
    static get_type_categorys(type_categorys,option){
        let return_items = [];
        option = option ? option :{get_any:false,blank:false};
        for(const item of type_categorys) {

            if(item.value){
                return_items.push({label:item.title,value:item.value});
            }else if(item.title){
                return_items.push({label:item.title,value:item.title});
            }
        }
        if(option.any){
            return_items.unshift({label:"Any",value:"Any"});
        }
        if(option.blank){
            return_items.unshift({label:"",value:""});
        }
        return return_items;
    }
    static get_type_category_search_filter(type,category){
        if(type == 'Any' && category == 'Any'){
            return {};
        }
        else{
            if(type != 'Any' && category != 'Any'){
                return {
                    $and: [
                        {type:type},
                        {category:category},
                    ]};
            }else{
                if(type != 'Any'){
                    return {type:type};
                }else{
                    return {category:category};
                }
            }
        }
    }
    static bind_field_values(item) {
        let field_values = [];
        for(let a=1;a<30;a++){
            if(item['field_'+String(a)]){
                let id = Num.get_id(333);
                let title = item['field_'+a];
                let value = String(item[Str.get_title_url(item['field_'+a])]).toLowerCase();
                let image_filename = Str.check_is_image(value) ? value :"";
                let new_item = {id:id,value:value,title:title,row_id:a,image_filename:image_filename};
                field_values.push(new_item);
            }
        }
        return field_values;
    };
    static bind_custom_fields(item,custom_fields) {
        let r_custom_fields = [];
        for(let a=0;a<custom_fields.length;a++){
            let custom_field = {
                key: Num.get_id(333),
                title:custom_fields[a].title,
                selected:item[Str.get_title_url(custom_fields[a].title.toLowerCase())],
                items:[],
            };
            for(let b=0;b<19;b++){
                if(!Str.check_is_null(custom_fields[a]['field_'+b]))   {
                    custom_field.items.push(
                        {
                            label:custom_fields[a]['field_'+b],
                            value:JSON.stringify({
                                key:custom_field.key,
                                field: Str.get_title_url(custom_fields[a].title.toLowerCase()),
                                title:custom_fields[a].title,
                                value:custom_fields[a]['field_'+String(b)]
                            })
                        });
                }
            }
            r_custom_fields.push(custom_field);
        }
        return r_custom_fields;
    };
}
class Image {
    static get_url(image_filename,size,option){
        option = !Obj.check_is_empty(option) ? option : {table:Portal_Table.PRODUCT};
        if(option.table == Portal_Table.USER){
            return image_filename?Image_Logic.get_url(Config.IMAGE_HOST,image_filename,size,Config.URL_CDN_PARAM):Config.URL_USER_NO_IMAGE;
        }else if(option.table == Portal_Table.CART){
            return image_filename?Image_Logic.get_url(Config.IMAGE_HOST,image_filename,size,Config.URL_CDN_PARAM):Config.URL_CART_NO_IMAGE;
        }else{
            return image_filename?Image_Logic.get_url(Config.IMAGE_HOST,image_filename,size,Config.URL_CDN_PARAM):Config.URL_PRODUCT_NO_IMAGE;
        }
    };
}
class Toast_Message {
    static loading = (message) =>{
        toast.dismiss();
        toast.loading(message);
    };
    static success = (message) =>{
        toast.dismiss();
        toast.success(message);
    };
    static error = (message) =>{
        toast.dismiss();
        toast.error(message);
    };
    static dismiss = () =>{
        toast.dismiss();
    };
}
class Storage {
    // -- base --
    static delete_all(){
        Storage_Data.delete_all();
    }
    // -- page --
    static post_page(page_title,value){
        Storage_Data.post(page_title,value,{time_limit:Config.CACHE_TIME_LIMIT});
    };
    static get_page(page_title){
        return Storage_Data.get(page_title,{time_limit:Config.CACHE_TIME_LIMIT});
    };
    static delete_pages(){
        // -- pages --
        Storage_Data.delete(Portal_Page.HOME.type);
        Storage_Data.delete(Portal_Page.BLOG_POST_HOME);
        Storage_Data.delete(Portal_Page.CONTACT);
        Storage_Data.delete(Portal_Page.FAQ);
        Storage_Data.delete(Portal_Page.GALLERY_HOME);
        // -- template --
        Storage_Data.delete(Type.KEY_CACHE_TEMPLATE);
        if(Config.ENVIRONMENT == Portal_Type.ENV_TEST){
            Log.w('biz.project.delete_pages',true);
        }
    };
    // -- template --
    static post_template(value){
        Storage_Data.post(Type.KEY_CACHE_TEMPLATE,value,{time_limit:Config.CACHE_TIME_LIMIT});
    };
    static get_template(){
        return Storage_Data.get(Type.KEY_CACHE_TEMPLATE,{time_limit:Config.CACHE_TIME_LIMIT});
    };
    // -- sub_value --
    static post_sub_value_group(sub_value_edit,sub_value_group){
        if(!Obj.check_is_empty(sub_value_group)){
            Storage_Data.post(Type.KEY_STORAGE_SUB_VALUE_GROUP+"_"+sub_value_edit.parent_table+"_"+sub_value_edit.parent_id,sub_value_group);
        }
    };
    static get_sub_value_group(sub_value_edit){
        return Storage_Data.get(Type.KEY_STORAGE_SUB_VALUE_GROUP+"_"+sub_value_edit.parent_table+"_"+sub_value_edit.parent_id) ? 	Storage_Data.get(Type.KEY_STORAGE_SUB_VALUE_GROUP+"_"+sub_value_edit.parent_table+"_"+sub_value_edit.parent_id) : {};
    };
    // -- dashboard --
    static post_dashboard_apps(apps){
        Storage_Data.post(Type.KEY_STORAGE_DASHBOARD_APPS,apps);
    };
    static get_dashboard_apps(){
        return Storage_Data.get(Type.KEY_STORAGE_DASHBOARD_APPS);
    };
    static delete_dashboard_old(){
        Storage_Data.delete(Type.KEY_STORAGE_DASHBOARD_SUB_MENU_CURRENT_ITEM_DATA);
        Storage_Data.delete(Type.KEY_STORAGE_DASHBOARD_SUB_MENU_CURRENT_ITEM_ID);
        Storage_Data.delete(Type.KEY_STORAGE_DASHBOARD_APPS);
        Storage_Data.delete(Type.KEY_STORAGE_SUB_VALUE);
        Storage_Data.delete(Type.KEY_STORAGE_DASHBOARD_SIDE_BAR);
        Storage_Data.delete(Type.KEY_STORAGE_USER_ORDER);
    }
    static post_dashboard_type_user(){
        Storage_Data.post(Type.KEY_STORAGE_DASHBOARD,Type.DASHBOARD_USER);
        Storage_Data.post(Type.KEY_STORAGE_DASHBOARD_SIDE_BAR,Title.USER_SIDE_BAR_DASHBOARD);
    };
    static post_dashboard_type_app(app_id,url,service_url){
        Storage_Data.post(Type.KEY_STORAGE_DASHBOARD,Type.DASHBOARD_APP);
        Storage_Data.post(Type.KEY_STORAGE_DASHBOARD_SIDE_BAR,Title.USER_SIDE_BAR_DASHBOARD);
        Storage_Data.post(Type.KEY_STORAGE_DASHBOARD_APP,{app_id:app_id,url:url,service_url:service_url});
    }
    static get_dashboard_type(){
        return Storage_Data.get(Type.KEY_STORAGE_DASHBOARD);
    };
    static get_dashboard_side_bar_type(){
        return Storage_Data.get(Type.KEY_STORAGE_DASHBOARD_SIDE_BAR);
    };
    static post_dashboard_side_bar(table){
        Storage_Data.post(Type.KEY_STORAGE_DASHBOARD_SIDE_BAR,table);
    };
    // -- app --
    static get_app(){
        return Storage_Data.get(Type.KEY_STORAGE_DASHBOARD_APP)?Storage_Data.get(Type.KEY_STORAGE_DASHBOARD_APP):{app_id:1,url:'blank',service_url:'blank'};
    };
    // -- cart --
    static post_cart(cart){
        Storage_Data.post(Type.KEY_STORAGE_USER_CART,cart);
    };
    static delete_cart(){
        Storage_Data.delete(Type.KEY_STORAGE_USER_CART);
    };
    static get_cart(){
        return Storage_Data.get(Type.KEY_STORAGE_USER_CART) ? Storage_Data.get(Type.KEY_STORAGE_USER_CART) : {};
    };
    // -- order --
    static post_order(order){
        Storage_Data.post(Type.KEY_STORAGE_USER_ORDER,order);
    };
    static get_order(){
        return Storage_Data.get(Type.KEY_STORAGE_USER_ORDER);
    };
    static delete_order(){
        return Storage_Data.delete(Type.KEY_STORAGE_USER_ORDER);
    };
    // -- favorites --
    static post_favorites(favorites){
        Storage_Data.post(Type.KEY_STORAGE_FAVORITES,favorites);
    };
    static get_favorites(){
        return Storage_Data.get(Type.KEY_STORAGE_FAVORITES) ? Storage_Data.get(Type.KEY_STORAGE_FAVORITES) : [];
    };
}
class Dashboard {
    static get_dash_edit_item_back_link = (table) =>{
        return "<- "+Str.get_table_by_name(table,{plural:true})
    };
}
class Template {
    static get_template_section(type){
        let template_section_list = [
            {value:Portal_Type.TEMPLATE_SECTION_HEADER,title:Portal_Title.TEMPLATE_SECTION_HEADER,label:Portal_Title.TITLE_TEMPLATE_SECTION_HEADER},
            {value:Portal_Type.TEMPLATE_SECTION_BODY,title:Portal_Title.TEMPLATE_SECTION_BODY,label:Portal_Title.TITLE_TEMPLATE_SECTION_BODY},
            {value:Portal_Type.TEMPLATE_SECTION_FOOTER,title:Portal_Title.TEMPLATE_SECTION_FOOTER,label:Portal_Title.TITLE_TEMPLATE_SECTION_FOOTER},
        ];
        return template_section_list.find(item_find => item_find.value === type)? template_section_list.find(item_find => item_find.value === type) : {value:Portal_Type.TEMPLATE_SECTION_BODY,title:Portal_Type.TEMPLATE_SECTION_BODY,label:Portal_Type.TEMPLATE_SECTION_BODY};
    };
    static get_template_sub_value_edit = (template_id,section_type) => {
        return {parent_table:Portal_Table.TEMPLATE,parent_id:template_id,section_type:section_type,event_handler:section_type + "_"+Field.MESSAGE};
    };
}
class System {
    static get_1_app(){
        return Data_Logic.get(Portal_Table.APP,1,
            {data:{
                title:Config.SYSTEM_1_TITLE,
                app_id:Config.SYSTEM_1_APP_ID,
                url:Config.SYSTEM_1_URL,
                service_url:Config.SYSTEM_1_SERVICE_URL,
                user_id:Config.SUPER_ADMIN_ID,
                status:Portal_Type.ENV_TEST
            }} );
    };
}
class Style {
    static customStyles = {
        option: (base: any, state: any) => ({
            ...base,
            color: "#6A7287",
            backgroundColor: state.isSelected ? "black" : "white",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: state.isFocused ? "#FF6900" : "white",
                color: state.isFocused ? "#fff" : "#6A7287",
            },
        }),
    };
    static override: CSSProperties = {
        display: "block",
        margin: "0 auto",
        borderColor: "orange",
    };
}
class Event {
    static get_stocks = () => {
        const stocks=
            [
                { value: "0", label: "No Sessions Availble" },
                { value: "1", label: "Ready For Booking" },
                { value: "2", label: "No Sessions Availble" }
            ];
        return stocks;
    };
    static get_stock_by_value = (stock_val) => {
        switch(stock_val)
        {
            case "0":
                return 'No Sessions Availble';
                break;
            case "1":
                return 'Ready For Booking';
                break;
            case "2":
                return 'No Sessions Availble';
                break;
        }
    };
    static get_test = () =>{
        let data = {};
        data.cost = Field_Logic.get_test_cost();
        data.old_cost = Field_Logic.get_test_cost();
        data.type = "Type "+String(Num.get_id());
        data.sub_type = "Sub Type "+String(Num.get_id());
        data.stock = String(Num.get_id(3-1));
        data.tag = "Tag "+ Num.get_id() + ", Tag "+Num.get_id() + ", Tag "+ Num.get_id();
        return data;
    };
}
class Service_Industry {
    static get_stocks = () => {
        const stocks =
            [
                { value: "0", label: "No Sessions Availble" },
                { value: "1", label: "Ready For Booking" },
                { value: "2", label: "No Sessions Availble" }
            ];
        return stocks;
    };
    static get_stock_by_value = (stock_val) => {
        switch(stock_val)
        {
            case "0":
                return 'No Sessions Availble';
                break;
            case "1":
                return 'Ready For Booking';
                break;
            case "2":
                return 'No Sessions Availble';
                break;
        }
    };
    static get_test = () =>{
        let data = {};
        data.cost = Field_Logic.get_test_cost();
        data.old_cost = Field_Logic.get_test_cost();
        data.type = "Type "+String(Num.get_id());
        data.sub_type = "Sub Type "+String(Num.get_id());
        data.stock = String(Num.get_id(3-1));
        data.tag = "Tag "+ Num.get_id() + ", Tag "+Num.get_id() + ", Tag "+ Num.get_id();
        return data;
    };
}
class User {
    static post(user){
        Storage_Data.post(Type.KEY_STORAGE_USER,user);
    }
    static get(){
        let user = Storage_Data.get(Type.KEY_STORAGE_USER);
        if(user){
            return user;
        }else{
            user = User_Logic.get_guest();
            User.post(user);
        }
    }
    static delete_old(){
        Storage_Data.delete(Type.KEY_STORAGE_USER);
        Storage_Data.delete(Type.KEY_STORAGE_FAVORITES);
    }
    static get_device(){
        return {name:platform.name,version:platform.version,layout:platform.layout,os:platform.os.architecture+"-"+platform.os.family,description:platform.description};
    };
}
export {
    App,
    Data,
    Dashboard,
    Event,
    Field_Logic,
    Image,
    Style,
    Service_Industry,
    Template,
    Toast_Message,
    Storage,
    System,
    User
};
